angular.module('app.directives').directive('vpPrintPanel', (api) => ({
    restrict: 'EA',

    scope: {
        model: '@',
        modelId: '@',
    },

    templateUrl: '/directives/print-panel/print_panel.html',
    transclude: true,

    link(scope, element, attrs) {
        scope.attachments = [];
        scope.selectedAttachments = [];
        scope.withAttachmentsHref = '';
        scope.loaded = false;

        scope.refresh = (clearCache) => {
            const path = `attachments/${scope.model || ''}/${scope.modelId || ''}`.replace(/\/+$/, '');
            const AttachmentsModel = api(path);

            if (clearCache) {
                AttachmentsModel.clearCache();
            }

            scope.loaded = false;
            AttachmentsModel.list().then(
                (response) => {
                    // important: filter out attachments that are not PDFs
                    scope.attachments = response.data.filter((attachment) => attachment.as_pdf || 'pdf' === attachment.file_ext);
                    scope.loaded = true;
                },
                () => {
                    scope.loaded = true;
                }
            );
        };

        scope.generateLinkForAttachmentsDownload = () => {
            const values = scope.selectedAttachments.filter((element) => 0 < element);

            scope.withAttachmentsHref = `${['/print', scope.model, scope.modelId].join('/')}?aid=${values.join(',')}`;
        };

        scope.$watch('modelId', (value) => {
            if (value) {
                scope.refresh();
                scope.generateLinkForAttachmentsDownload();
            }
        });

        scope.$watch(
            () => angular.toJson(scope.selectedAttachments),
            () => {
                scope.generateLinkForAttachmentsDownload();
            }
        );
    },
}));
